import Link from "./Link";
import TimeField from "./TimeField";
import GPSField from "./GPS";
import SingleChoice from "./SingleChoice";
import Calculation from "./Calculation";
import Photo from "./Photo";
import Summary from "./Summary";
import Payment from "./Payment";
import NumberField from "./Number";
import Checkbox from "./Checkbox"; // import the entire default object
import Text from "./Text";
import Rating from "./Rating";
import MultipleChoice from "./MultipleChoice";
import LongText from "./LongText";
import DateField from "./DateField";
import { getValue } from "../utils";
import { getValue as getNumberValue } from "./Number";

// original_type_id options
export const SINGLE_PHOTO_ORIGINAL_TYPE_ID = 10;
export const DRAWING_ORIGINAL_TYPE_ID = 98;
export const SIGNATURE_ORIGINAL_TYPE_ID = 99;
export const SHORT_TEXT_ORIGINAL_TYPE_ID = 0;
export const LONG_TEXT_ORIGINAL_TYPE_ID = 8;

// Number styles
export const NUMBER_STYLE = 0;
export const CURRENCY_STYLE = 4;
// Single choice styles
export const SINGLE_CHOICE_DROPDOWN_STYLE = 3;
export const SINGLE_CHOICE_EDITABLE_DROPDOWN_STYLE = 34;
// Text styles
export const TEXT_STYLE = 0;
export const TEXT_EMAIL_FORMAT_STYLE = 10;
export const TEXT_EMAIL_FORMAT_ALWAYS_STYLE = 11;
export const TEXT_NUMBER_FORMAT_STYLE = 6;

// Field label length when using LABELS_LEFT sheet type
export const LABELS_LEFT_ENTRY_LABEL_LENGTH = 30;
// Field label length when using the Tile Photo format on a Single Photo Field
export const TILE_PHOTO_ENTRY_LABEL_LENGTH = 30;
const allFields = [Link, TimeField, SingleChoice, GPSField, Calculation, Photo, Payment, NumberField, Summary, Checkbox, Text, Rating, MultipleChoice, LongText, DateField];
export const nonFunctionalValidity = [{
  type: 'required',
  validation: ({
    value,
    required
  }) => {
    const isEmpty = !value || value === 'BLANK' || value === null;
    if (required && isEmpty) {
      return 'This field is required';
    }
  }
}];
const validityMethods = allFields.reduce((acc, field = {}) => {
  const {
    type = 'unknown',
    validity = nonFunctionalValidity
  } = field;
  acc[type] = validity;
  return acc;
}, {});
const BaseField = {
  entry_values: [],
  default: null,
  required: false,
  read_only: false,
  summary_entry: {}
};
export const getFieldDefaults = fieldType => {
  const fieldDefault = allFields.find(({
    type
  }) => fieldType === type) || {};
  const {
    defaultValue = {}
  } = fieldDefault;
  return {
    ...BaseField,
    ...defaultValue
  };
};

// validateField :: Object -> Array
export const validateField = (previewEntry = {}, options = {}) => {
  const {
    type,
    keyField
  } = previewEntry;
  const {
    disableRequired = false
  } = options;
  const entryValidations = validityMethods[type] || nonFunctionalValidity;
  return entryValidations.reduce((validations, {
    type,
    validation = () => ''
  }) => {
    if (!disableRequired || type !== 'required' && previewEntry.value || keyField) {
      validations.push({
        type,
        errorMessage: validation(previewEntry)
      });
    }
    return validations;
  }, []);
};

// applyValidations :: Object -> Object
export const applyValidations = (previewEntry = {}, options = {}) => {
  const errorMessages = validateField(previewEntry, options);
  const errors = errorMessages.reduce((message, {
    errorMessage = ''
  }) => `${message}${message && errorMessage ? ', ' : ''}${errorMessage}`, '');
  return {
    ...previewEntry,
    isValid: errors.length === 0,
    errors
  };
};

// used when the field needs to be shown as text, outside of the field component context
// getFormattedValue :: Object -> String
export const getFormattedValue = entry => {
  const {
    type,
    value,
    mirror = false
  } = entry;
  if (type === 'Number') {
    return getNumberValue(entry);
  }
  return getValue(type, value, mirror);
};
export { Link, TimeField, GPSField, SingleChoice, Calculation, Checkbox, Photo, Summary, Payment, NumberField, Text, Rating, MultipleChoice, LongText, DateField };